import { Typography } from "../../shared/ui";
import css from "./ReloadModal.module.scss";

export const ReloadModal = () => {
  return (
    <div className={css.container}>
      <Typography variant="h3" color="header">
        You’ve been disconnected!
      </Typography>
      <p>
        Check connection and refresh your browser, or go back to landing page
      </p>
      <button onClick={() => location.reload()}>REFRESH</button>
    </div>
  );
};
